// https://webpack.js.org/guides/typescript/#importing-other-assets

declare module "*.svg" {
  const content: unknown;
  export default content;
}

declare module "*.png" {
  const content: string;
  export default content;
}

declare module "moment-timezone" {
  import moment from "moment-timezone";
  export = moment;
}
